import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Talk to MISTR',
    desc: 'Voice, text, Slack, or email. Say what you need in plain language.'
  }, {
    num: '2',
    title: 'MR Understands',
    desc: 'Pulls context from your entire business. Knows the history, team, and goals.'
  }, {
    num: '3',
    title: 'Action Happens',
    desc: 'Tasks created. Emails sent. Campaigns managed. Follow-ups handled.'
  }, {
    num: '4',
    title: 'You Get Results',
    desc: 'Reports, updates, and confirmations. Always informed, never in the weeds.'
  }];
  return <section className="section-padding bg-section-gradient overflow-hidden relative" data-id="element-331">
      <div className="inner-container relative z-10" data-id="element-332">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-333">
          <span className="text-teal text-sm font-poppins font-bold uppercase tracking-widest" data-id="element-334">
            How It Works
          </span>
          <h2 className="font-poppins font-extrabold text-4xl md:text-5xl leading-tight mt-4 text-white" data-id="element-335">
            Say It. Done.
          </h2>
        </div>

        <div className="relative max-w-6xl mx-auto" data-id="element-336">
          {/* Animated Connector Line */}
          <div className="hidden md:block absolute top-14 left-[10%] right-[10%] h-1 overflow-hidden rounded-full" data-id="element-337">
            <div className="h-full bg-gradient-to-r from-purple/20 via-teal/20 to-purple/20" data-id="element-338" />
            <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-purple/40 to-transparent" initial={{
            x: '-100%'
          }} animate={{
            x: '200%'
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-339" />
          </div>

          <div className="grid md:grid-cols-4 gap-12 relative z-10" data-id="element-340">
            {steps.map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.2
          }} className="flex flex-col items-center text-center group" data-id="element-341">
                {/* Gradient Circle */}
                <div className="relative w-28 h-28 mb-6" data-id="element-342">
                  <div className="absolute inset-0 rounded-full bg-gradient-to-br from-purple to-teal p-[3px] shadow-[0_0_20px_rgba(124,58,237,0.2)] group-hover:shadow-[0_0_30px_rgba(124,58,237,0.4)] transition-shadow" data-id="element-343">
                    <div className="w-full h-full rounded-full bg-dark-bg flex items-center justify-center" data-id="element-344">
                      <span className="text-4xl font-poppins font-bold bg-gradient-to-br from-purple to-teal bg-clip-text text-transparent" data-id="element-345">
                        {step.num}
                      </span>
                    </div>
                  </div>
                </div>
                <h3 className="font-poppins font-bold text-lg mb-3 text-white" data-id="element-346">
                  {step.title}
                </h3>
                <p className="text-steel text-sm leading-relaxed" data-id="element-347">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}